export const preferredLanguagesChangedEvent = "smartguide:preferred-languages-changed";
type TurboWindow = Window & { Turbo?: { cache: { clear(): void }; visit(url: string): void } };

export function visitPreferredLanguageSettings(focusLanguage?: string): void {
    if (focusLanguage) document.addEventListener("turbo:load", () => {
        [...document.querySelectorAll<HTMLElement>("[data-language]")]
            .find(row => row.dataset.language === focusLanguage)?.querySelector<HTMLButtonElement>(".profile-drag-handle")?.focus();
    }, { once: true });
    const turbo = (window as TurboWindow).Turbo;
    if (turbo) turbo.visit("/profile/languages");
    else window.location.assign("/profile/languages");
}

export class PreferredLanguageNavigation {
    private previous?: string;
    private exploreUrl = "/";
    private connected = false;
    private readonly beforeRender = (event: Event): void => {
        const body = (event as CustomEvent<{ newBody: HTMLElement }>).detail?.newBody;
        if (body) {
            refreshSmartGuideFrontendSettings(body);
            refreshPermanentUiTranslations(body);
        }
    };
    private readonly refresh = (): void => {
        refreshSmartGuideFrontendSettings();
        if (!/^\/profile(?:\/|$)/.test(window.location.pathname)) {
            this.exploreUrl = window.location.pathname + window.location.search + window.location.hash;
        } else {
            document.querySelectorAll<HTMLAnchorElement>("[data-smartguide-bottom-navigation] [data-smartguide-bottom-navigation-key=explore]")
                .forEach(link => link.setAttribute("href", this.exploreUrl));
        }
        const value = document.body.dataset.preferredLanguages ?? "[]";
        if (this.previous !== undefined && value !== this.previous) {
            (window as TurboWindow).Turbo?.cache.clear();
            window.dispatchEvent(new CustomEvent(preferredLanguagesChangedEvent, { detail: { languages: JSON.parse(value) as string[] } }));
        }
        this.previous = value;
    };

    connect(): void {
        if (this.connected) return;
        this.connected = true;
        this.refresh();
        document.addEventListener("turbo:before-render", this.beforeRender);
        document.addEventListener("turbo:load", this.refresh);
    }

    disconnect(): void {
        document.removeEventListener("turbo:before-render", this.beforeRender);
        document.removeEventListener("turbo:load", this.refresh);
        this.connected = false;
    }
}

function refreshPermanentUiTranslations(body: HTMLElement): void {
    body.querySelectorAll<HTMLElement>("[id][data-turbo-permanent]").forEach(incoming => {
        const current = document.getElementById(incoming.id);
        if (!current) return;
        for (const marker of ["data-ui-text", "data-ui-aria"]) {
            incoming.querySelectorAll<HTMLElement>(`[${marker}]`).forEach(source => {
                current.querySelectorAll<HTMLElement>(`[${marker}]`).forEach(target => {
                    if (source.getAttribute(marker) !== target.getAttribute(marker)) return;
                    if (marker === "data-ui-text") target.textContent = source.textContent;
                    else {
                        const translatedLabel = source.getAttribute("aria-label") ?? "";
                        target.setAttribute("aria-label", translatedLabel);
                    }
                });
            });
        }
        const detailLabel = incoming.querySelector<HTMLElement>("[data-persistent-audio-player-detail-label]")?.dataset.persistentAudioPlayerDetailLabel;
        if (detailLabel) current.querySelectorAll<HTMLElement>("[data-persistent-audio-player-detail-label]").forEach(link => {
            link.dataset.persistentAudioPlayerDetailLabel = detailLabel;
            if (link.hasAttribute("href")) link.setAttribute("aria-label", detailLabel);
        });
    });
}
import { refreshSmartGuideFrontendSettings } from "../webTranslations";

